import * as types from '../../actions/actiontypes';
import initialState from '../initialstate';

export function copyhubPackageDetailsReducer(state = initialState.copyhubPackageDetails, action) {
        switch (action.type) {
                case types.GET_COPYHUB_PACKAGE_DETAILS: {
                        return action.response;
                };

                case types.RESET_PACKAGE_DETAILS_MODAL: {
                        return initialState.copyhubPackageDetails;
                };

                default:
                        return state;
        }
}

export function associateTaskToggleReducer(state = initialState.associateTaskToggle, action) {
        switch (action.type) {
                case types.SET_ASSOCIATE_TASK_COUNTER: {
                        let newstate = action.count;
                        return newstate;
                }
                default:
                        return state;
        }
}